<template>
  <div class="BaseSetPsw-container">
    <section class="my-wrap">
      <h3 class="my-title">设置密码</h3>
      <div style="position: relative; margin-bottom: 30px;">
        <el-input
          size="large"
          prefix-icon="el-icon-key"
          v-model="password"
          maxlength="12"
          placeholder="6～12位数字、字母组合"
          show-password
          @input="toggleErrorTip(false)"
          @keyup.native.enter="doConfirm()"
        />
        <p class="my-error" v-text="'密码格式有误'" v-show="isErrorShown" @input="toggleErrorTip(false)"></p>
      </div>
      <div>
        <el-button size="large" type="primary" @click="doConfirm" style="width: 100%;">确定</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseSetPsw',
  components: {
  },
  data() {
    return {
      password: '',
      isErrorShown: false
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toggleLoading(v) {
      console.log(v)
    },
    toggleErrorTip(v = !this.isErrorShown) {
      this.isErrorShown = v
    },
    checkPsw() {
      return this.password.length >= 6 && this.password.length <= 12
    },
    doConfirm() {
      if (!this.checkPsw()) {
        this.toggleErrorTip(true)
        return
      }
      this.toggleLoading(true)
      this.$api.axiosSetPsw({
        password: this.password
      }).then(res => {
        if (res.isOk) {
          this.$message.success('设置成功');
          this.$emit('success')
        } else {
          let msg = res.msg || (res.message || {}).title || '设置失败'
          this.$message.error(msg);
        }
      }).catch(e => {
        console.error(e)
        this.$utHintMessage('error', '网络连接失败', { center: true });
      }).then(() => this.toggleLoading(false))
    },
  }
}
</script>

<style lang="less" scoped>
.BaseSetPsw-container {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background: #fff;
  z-index: 1999;
  box-sizing: border-box;
}
.my-wrap {
  margin-top: -50px;
}

.my-title {
  margin-bottom: 40px;
  font-size: 20px;
  text-align: center;
}

.my-error {
  position:absolute;
  color: red;
  font-size: 14px;
}
</style>
